<template>
  <div>
    <a-affix :offsetTop="this.$store.getters.shutdownTriggered ? 103 : 50">
      <a-card class="breadcrumb-card" style="z-index: 10">
        <a-row :gutter="[12,12]">
          <a-col :span="device === 'mobile' ? 24 : 12" style="padding-left: 12px; margin-top: 10px">
            <breadcrumb :resource="resource">
              <template #end>
              </template>
            </breadcrumb>
          </a-col>
          
          <a-col
          :span="device === 'mobile' ? 24 : 12"
          :style="device === 'mobile' ? { float: 'right', 'margin-top': '12px', 'margin-bottom': '-6px', display: 'table' } : { float: 'right', display: 'table', 'margin-top': '6px' }" >
          
        </a-col>
      </a-row>
    </a-card>
  </a-affix>
  <a-row :gutter="[12,12]">
    <a-col :span="24">
      <a-card>
        <a-row :gutter="[12,12]" style="padding-bottom:15px;">
          <h1 class="onboard-title">{{ $t('label.onboard.first_deployment.intro') }}</h1>
        </a-row>
        <a-row :gutter="[12,12]">
          
          <a-col :span="24">
            <h3>{{ $t('label.onboard.first_deployment.howtodeploy') }}</h3>
          </a-col>
        </a-row>
        <a-row :gutter="[12,12]">
          <a-col :span="24" class="block-justify">
            {{$t('label.onboard.first_deployment.intro-text-00')}}
            <br />
          </a-col>
        </a-row>
        <a-row :gutter="[12,12]">
          <a-col :span="17" class="block-justify" style="padding-top:20px;">
            <h2 class="onboard-subtitle">{{ $t('label.onboard.first_deployment.ssh-00') }}</h2>
            <p>
              <br />
              {{ $t('label.onboard.first_deployment.ssh-01') }}
              <ol>
                <li>{{ $t('label.onboard.access_section') }} <strong class="text-linube">{{ $t('label.ssh.key.pairs') }}</strong> en
                    {{ $t('label.onboard.in_side_menu') }}
                </li>
                  <li>{{ $t('label.onboard.click_on') }} <strong class="text-linube">{{ $t('label.create.ssh.key.pair') }}</strong> y
                    {{ $t('label.onboard.first_deployment.ssh-02') }}
                  </li>
                  <li>{{ $t('label.onboard.click_on') }} <strong class="text-linube">{{ $t('label.save') }} </strong> {{ $t('label.onboard.first_deployment.ssh-03') }}
                  </li>
                  
                </ol>
              </p>
              <img src="/assets/onboarding/deployments/10-ssh-keys-overview.png" class="block-center-img" />
            </a-col>
            <a-col :span="7" class="block-center">
              <img src="/assets/onboarding/deployments/12-new-ssh-key-filled.png" class="block-center-img" />
            </a-col>
            
            <a-col :span="24" class="block-center">
            </a-col>
            
          </a-row>
          
        </a-card>
      </a-col>
    </a-row>
    <a-row :gutter="[12,12]">
      <a-col :span="24">
        <a-card>
          <a-row :gutter="[12,12]">
            <a-col :span="24" class="block-justify">
              <h3 class="onboard-subtitle">{{ $t('label.onboard.first_deployment.create_network-00') }}</h3>
            </a-col>
            <a-col :span="16" class="block-justify">
              <p>
                {{$t('label.onboard.first_deployment.create_network-01')}}
              </p>
              <p> {{ $t('label.onboard.access_section')}} 
                <strong class="text-linube"> {{ $t('label.networks') }} </strong> 
                {{ $t('label.onboard.in_side_menu') }} {{ $t('label.onboard.first_deployment.create_network-02') }} 
                 <strong class="text-linube"> {{ $t('label.guest.networks') }}</strong>. 
               {{ $t('label.onboard.clik_tap_button')}} 
               <strong class="text-linube"> {{  $t('label.add.guest.network') }} </strong>
               {{  $t('label.onboard.first_deployment.create_network-03') }}
              </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/00-add-network.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  {{ $t('label.onboard.first_deployment.create_network-04')}}
                  <ul>
                    <li>{{  $t("label.isolated.networks") }}</li>
                    <li>{{  $t("label.l2") }}</li>
                    <li>{{  $t("label.shared") }}</li>
                  </ul>
                  {{ $t('label.onboard.first_deployment.create_network-05')}} <strong class="text-linube"> {{  $t("label.isolated") }} </strong>, 
                  {{ $t('label.onboard.first_deployment.create_network-06') }}<br/>
                  {{ $t('label.onboard.first_deployment.create_network-07') }}
                  <ul>
                    <li> {{ $t('label.onboard.first_deployment.create_network-08') }}</li>
                    <li> {{ $t('label.onboard.first_deployment.create_network-09') }}</li>
                    <li> {{ $t('label.onboard.first_deployment.create_network-11') }} <router-link to="/onboard/first_project"> {{ $t('label.project') }}</router-link> {{ $t('label.onboard.first_deployment.create_network-12') }} </li>
                    <li> {{ $t('label.onboard.first_deployment.create_network-13')}} </li>
                    <li> {{ $t('label.onboard.first_deployment.create_network-14') }}</li>
                    <li> {{ $t('label.onboard.first_deployment.create_network-15') }}</li>
                    <li> {{ $t('label.onboard.first_deployment.create_network-16') }}</li>
                  </ul>
                </p>
                <p>
                  {{ $t('label.onboard.first_deployment.create_network-17') }} <span class="text-linube">{{ $t("label.allocated") }}</span> {{ $t('label.onboard.first_deployment.create_network-18') }}
                  <br/>
                  {{ $t('label.onboard.first_deployment.create_network-19') }} <span class="text-linube">{{ $t("label.implemented") }}</span> 
                </p>
                <p>
                  {{ $t('label.onboard.first_deployment.create_network-20') }}
                </p>
              <a-col :span="20" class="block-center">
                <img src="/assets/onboarding/deployments/02-network-overview.png" class="block-center-img" />
              </a-col>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/01-add-isolated-network.png" class="block-center-img" />
              </a-col>

              <a-col :span="16" class="block-justify">
                <h2 class="onboard-subtitle">{{ $t('label.onboard.first_deployment.create_network-21') }}</h2>
                <p> {{ $t('label.onboard.first_deployment.create_network-22') }}
                  <ul>
                    <li> {{  $t('label.onboard.first_deployment.create_network-23') }}</li>
                    <li> {{  $t('label.onboard.first_deployment.create_network-24') }}</li>
                    <li> {{  $t('label.onboard.first_deployment.create_network-25') }}</li>
                    <li> {{  $t('label.onboard.first_deployment.create_network-26') }}</li>
                    <li> {{  $t('label.onboard.first_deployment.create_network-27') }}</li>
                    <li> {{  $t('label.onboard.first_deployment.create_network-28') }}</li>
                  </ul>
                </p>
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  {{ $t('label.onboard.first_deployment.create_network-29')}} <strong class="text-linube">{{ $t('label.acquire.new.ip') }}</strong>.
                  <br/>
                  {{  $t('label.onboard.first_deployment.create_network-30') }}
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/04-network-details-public-ip.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/05-network-public-ip-acquire.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/06-network-public-ips.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/07-network-egress-rules.png" class="block-center-img" />
              </a-col>
              <a-col :span="24" class="block-justify">
                <p>
                  
                </p>
              </a-col>
            </a-row>
          </a-card>
        </a-col>
      </a-row>
      <a-row :gutter="[12,12]">
        <a-col :span="24">
          <a-card>
            
            <a-row :gutter="[12,12]">
              <a-col :span="24" class="block-justify">
                <h3>Crear una instancia</h3>
              </a-col>
              <a-col :span="24" class="block-center">
                <img src="/assets/onboarding/deployments/08-instance-overview.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/09-instance-new-button.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/13-instance-new.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/14-instance-account.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/15-instance-zone.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/16-instance-template.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/17-instance-offering.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/18-instance-offering-custom-disk" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/19-instance-networking.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/20-instance-ssh-keys.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/21-instance-host-group.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/22-instance-launch.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/23-instance-launching.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/24-instance-starting.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/25-instance-kvm.png" class="block-center-img" />
              </a-col>
              
            </a-row>
            
            
            <a-row :gutter="[12,12]">
              <a-col :span="24" class="block-justify">
                <h3>Configurar reenvío de puertos</h3>
              </a-col>
              <a-col :span="24" class="block-center">
                <img src="/assets/onboarding/deployments/26-network-implemented.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/27-network-details-public-ips.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/28-network-port-forwarding.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/29-network-port-forward-add-instance.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/30-network-port-forward-add-instance-button.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
              <a-col :span="8" class="block-center">
                <img src="/assets/onboarding/deployments/31-network-rule-added.png" class="block-center-img" />
              </a-col>
              <a-col :span="16" class="block-justify">
                <p>
                  TEXTO
                </p>
              </a-col>
            </a-row>
          </a-card>
        </a-col>
      </a-row>
      
    </div>
  </template>
  
  <script>
  import { mixinDevice } from '@/utils/mixin.js'
  import Breadcrumb from '@/components/widgets/Breadcrumb'
  export default {
    name: 'DeployNetworkAndInstance',
    components: {
      Breadcrumb,
      
    },
    mixins: [mixinDevice],
    data () {
      return {
        resource: {},
      }
    },
  }
</script>

<style scoped>
.breadcrumb-card {
  margin-left: -24px;
  margin-right: -24px;
  margin-top: -16px;
  margin-bottom: 12px;
}

.row-element {
  margin-bottom: 10px;
}

.ant-breadcrumb {
  vertical-align: text-bottom;
}

:deep(.ant-switch-inner) {
  display: block;
  font-size: 14px;
  margin: 0px 14px 0px 28px;
}

:deep(.ant-alert-message) {
  display: flex;
  align-items: center;
}

.hide {
  display: none !important;
}
</style>
